<template>
  <el-dialog class="el-dialogs" title="评审建议" :append-to-body="true" width="500px" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form size="small" class="query-form" ref="searchForm" :model="searchForm" :rules="rules"
             label-position="top" @keyup.enter.native="doSubmit()" label-width="80px">
      <div class="flex_l_c">
        <div style="width: 80px">评审结果：</div>
        <el-form-item label-width="0" prop="auditState">
          <el-radio-group v-if="type == '标引'" v-model="searchForm.auditState">
            <el-radio label="2">审核通过</el-radio>
            <el-radio label="3">审核驳回</el-radio>
          </el-radio-group>
          <el-radio-group v-else v-model="searchForm.auditState">
            <el-radio label="2">审核通过</el-radio>
            <el-radio label="4">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item key="keyq" v-if="searchForm.auditState == '2'" label="请填写评审建议：" prop="processOpinion">
        <el-input
            type="textarea"
            :rows="5" resize="none"
            maxlength="100"
            placeholder="请输入内容(限100字)"
            v-model="searchForm.processOpinion">
        </el-input>
      </el-form-item>
      <el-form-item key="uyab" v-else label="请填写评审建议：" prop="processOpinionNew">
        <el-input
            type="textarea"
            :rows="5" resize="none"
            maxlength="100"
            placeholder="请输入内容(限100字)"
            v-model="searchForm.processOpinionNew">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "setToexamine",
  data() {
    return {
      visible: false,
      searchForm: {
        auditState: '2',
        processOpinion: '',
        processOpinionNew:'',
      },
      rules: {
        processOpinionNew: [
          {required: true, message: '请填写评审建议', trigger: 'blur'}
        ]
      },
      type: '',
      url: '',
      ids: [],
    }
  },

  methods: {
    //type 标引 借阅
    //url请求地址
    init(ids, type, url) {
      this.visible = true
      this.type = type
      this.url = url
      this.ids = ids
      this.$nextTick(() => {
        this.$refs.searchForm.resetFields()
      })
    },

    //确定
    doSubmit() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          if (this.searchForm.auditState != '2') {
            this.searchForm.processOpinion = this.searchForm.processOpinionNew
          }
          this.$axios(this.url, {
            ...this.searchForm,
            ids: this.ids,
          }, 'post').then(data => {
            if (data && data.status) {
              this.$message.success(`${this.searchForm.auditState == '2' ? '通过' : '驳回'}成功`)
              this.$emit('refresh')
              this.visible = false
              //更新我的未读信息
              this.$store.commit('user/updateUserMessage')
            } else {
              this.$message.error(data.msg)
              this.$emit('refresh')
              this.visible = false
            }
          })
        }
      });
    },
  },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
  height: auto !important;
}
</style>